module.exports = __webpack_public_path__ + "img/logo-ticketshop-carousel.76b58b3d.png";